import { IconButton, IconButtonProps } from '@mui/material';
import { DisableableTooltip } from 'components/DisableableTooltip';
import React from 'react';

interface Props extends IconButtonProps {
  tooltip?: string;
  disabledTooltip?: string;
}

export const IconButtonTooltip: React.FC<Props> = ({ tooltip, disabledTooltip, ...iconButtonProps }) => {
  const { disabled } = iconButtonProps;

  return (
    <DisableableTooltip title={disabled ? disabledTooltip : tooltip} disabled={disabled ? !disabledTooltip : false} disableInteractive>
      <IconButton {...iconButtonProps}>
        {iconButtonProps.children}
      </IconButton>
    </DisableableTooltip>
  );
};